import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const TrioUniPelletDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazan pe peleți <span className={styles.highlight}>Trio Uni Pellet</span></p>
      <p className={styles.text}>
        Centrala pe peleți Trio Uni Pellet este prevazut pentru încălzirea locuințelor și unităților industriale în regim automat. Peleții sunt transportați cu ajutorul șnecului din buncăr, care se afla lângă cazan. Combustibilul potrivit pentru cazanul  Trio Uni Pellet se considera peleți care corespund clasei DIN plus.
      </p>
      <h3>
        Caracteristicile de pelete recomandate:
      </h3>
      <ul>
        <li>
          Umiditate max 10%
        </li>
        <li>
          Diametru intre 6 și 8 mm
        </li>
        <li>
          Lungime 25-40 mm
        </li>
      </ul>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-info" />
          <p>
            Este posibila exploatarea cazanului în regim de alimentare manuala a combustibilului solid. Pentru trecerea la acest regim este nevoie sa comandați din fabrica următoarele accesorii: ventilator, unitate automatizare, grătare fonta (pentru 20 pana la 50 kW) și ușiță de fonta.
          </p>
        </div>
      </div>
      <h1 className={styles.title}>Caracteristici</h1>
      <p className={styles.text}>
        Grosimea carcasei din otel și a schimbătorului de căldura a cazanului este de 6 mm. Acesta este un indicator important, deoarece viata cazanului depinde direct de acesta.
      </p>
      <p className={styles.text}>
        In complectație de baza a cazanului Trio Uni Pellet este montat este montat arzătorul de peleți de înaltă performanta Eco-Palnik, al producătorului polonez. Este echipat cu funcția de aprindere automata. Peleții sunt alimentați de la buncăr prin șnecul de alimentare la conducta ondulata prin care este alimentat porționat arzătorul, într-o camera de ardere din otel rezistent la căldura. Arzătorul este curățat automat prin mișcarea grătarelor și suflarea turbinelor. Arzătorul este complet automatizat, în toate fazele procesului de ardere - aprindere, ardere, așteptare, stingere se programează. Construcția arzătorului exclude pericolul supraîncălzirii cazanului în absenta alimentarii cu energie electrica, deoarece cantitatea combustibilului pe grătar este suficient de mica. În cazul penelor de curent electric, arzătorul oprește și pornește automat.
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-plus" />
          <p>

            La comanda, pe cazanul Trio Uni Pellet se pot monta și alte arzătoare, ai altor producători.
            <p className={styles.text}>Reglatorului tirajului de aer cu lanț se comandă separat.</p>
          </p>
        </div>
      </div>
      <p className={styles.text}>
        Pentru posibilitatea funcționarii cazanului cu combustibil solid în regimul alimentarii manuale a cuptorului (ex- lemn de foc), în complectație cu cazanul sunt prevazute grătare de apa . In plus ,pe peretele superior al corpului cazanului este prevazut un orificiu pentru instalarea ventilatorului (închis cu un capac), are va sufla aerul în camera de ardere.
      </p>
      <p className={styles.text}>
        Controlerul centralei TRIO UNI Pellet, măsoară permanent temperatura apei, astfel direcționând alimentarea automata a combustibilului. Controlerul este conectat la pompa de circulație a sistemului de încălzire.
      </p>
      <p className={styles.text}>
        Întreținerea funcționalității cazanului consta în adăugarea periodica a combustibilului în buncăr și îndepărtarea cenușii de pe raftul cenușar al cazanului, fără a fi necesara stingerea acestuia. După aprinderea centralei nu este nevoie de o supraveghere permanenta a acestuia. Funcționalitatea cazanului poate a dura pentru întregul sezon de încălzire fără a fi întreruptă. Centrala de asemenea poate fi folosita și în afara sezonului rece, pentru încălzirea apei, legata în sistem cu un boiler.
      </p>
      <p className={styles.text}>
        Cazanele au gura de evacuare de forma rotunda și au un șubler, cu ajutorul căruia controlam tirajul de evacuare a gazelor arse,pentru economisirea combustibilului.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>20 kW</th>
              <th>30 kW</th>
              <th>40 kW</th>
              <th>50 kW</th>
              <th>65 kW</th>
              <th>80 kW</th>
              <th>97 kW</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
              <th>300 kW</th>
              <th>400 kW</th>
              <th>500 kW</th>
              <th>600 kW</th>
              <th>700 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Suprafața schimbătorului de căldura</td>
              <td>m²</td>
              <td>2,0</td>
              <td>2,2</td>
              <td>3,0</td>
              <td>4,0</td>
              <td>4,7</td>
              <td>6,0</td>
              <td>8,0</td>
              <td>10,0</td>
              <td>15,0</td>
              <td>18,5</td>
              <td>27,0</td>
              <td>31,0</td>
              <td>37,0</td>
              <td>45,0</td>
              <td>52</td>
            </tr>
            <tr>
              <td>Eficiența, Min</td>
              <td>%</td>
              <td colSpan="15">91</td>
            </tr>
            <tr>
              <td>Volumul buncărului</td>
              <td>dm³</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>500</td>
              <td>500</td>
              <td>500</td>
              <td>1000</td>
              <td>1000</td>
              <td>1000</td>
              <td>1000</td>
              <td>1000</td>
              <td>1000</td>
              <td>1000</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>75</td>
              <td>80</td>
              <td>100</td>
              <td>140</td>
              <td>160</td>
              <td>190</td>
              <td>265</td>
              <td>325</td>
              <td>455</td>
              <td>545</td>
              <td>750</td>
              <td>840</td>
              <td>970</td>
              <td>1200</td>
              <td>1400</td>
            </tr>
            <tr>
              <td>Greutatea cazanului fără apa</td>
              <td>kg</td>
              <td>410</td>
              <td>440</td>
              <td>540</td>
              <td>630</td>
              <td>680</td>
              <td>780</td>
              <td>900</td>
              <td>1050</td>
              <td>1550</td>
              <td>2010</td>
              <td>2600</td>
              <td>2920</td>
              <td>3500</td>
              <td>4440</td>
              <td>4700</td>
            </tr>
            <tr>
              <td>Tirajul necesar a gazelor arse</td>
              <td>Pa</td>
              <td colSpan="15">23-30</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="15">100-180</td>
            </tr>
            <tr>
              <td>Temperatura apei min. recomandata</td>
              <td>°C</td>
              <td colSpan="15">58</td>
            </tr>
            <tr>
              <td>Temperatura max a apei</td>
              <td>°C</td>
              <td colSpan="15">90</td>
            </tr>
            <tr>
              <td>Presiunea nominala a apei (maxim)</td>
              <td>mPa</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="17">Consumul de energie electrică, min</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>În proces de exploatare</td>
              <td>W</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>100</td>
              <td>100</td>
              <td>100</td>
              <td>500</td>
              <td>500</td>
              <td>500</td>
              <td>500</td>
              <td>1025</td>
              <td>1025</td>
            </tr>
            <tr>
              <td>La aprindere</td>
              <td>W</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>800</td>
              <td>1200</td>
              <td>1200</td>
              <td>1200</td>
              <td>1200</td>
              <td>2100</td>
              <td>2100</td>
            </tr>
            <tr>
              <td>Diametrul extern racord coș</td>
              <td>mm</td>
              <td>159</td>
              <td>159</td>
              <td>178</td>
              <td>219</td>
              <td>219</td>
              <td>248</td>
              <td>248</td>
              <td>298</td>
              <td>298</td>
              <td>348</td>
              <td>398</td>
              <td>448</td>
              <td>498</td>
              <td>548</td>
              <td>548</td>
            </tr>
            <tr>
              <td>Diametru cot conexiune rețea de apă</td>
              <td>mm</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>65(FL)</td>
              <td>65(FL)</td>
              <td>80(FL)</td>
              <td>100(FL)</td>
              <td>100(FL)</td>
              <td>100(FL)</td>
              <td>125(FL)</td>
              <td>125(FL)</td>
              <td>125(FL)</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="17">Dimensiuni pentru burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>201</td>
              <td>201</td>
              <td>248</td>
              <td>377</td>
              <td>377</td>
              <td>452</td>
              <td>452</td>
              <td>660</td>
              <td>660</td>
              <td>908</td>
              <td>1194</td>
              <td>1520</td>
              <td>1885</td>
              <td>2290</td>
              <td>2290</td>
            </tr>
            <tr>
              <td>Diametrul intern</td>
              <td>mm</td>
              <td>160</td>
              <td>160</td>
              <td>180</td>
              <td>220</td>
              <td>220</td>
              <td>250</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
              <td>450</td>
              <td>500</td>
              <td>550</td>
              <td>550</td>
            </tr>
            <tr>
              <td>Înălțime (min. permisă)</td>
              <td>m</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>6</td>
              <td>6</td>
              <td>7</td>
              <td>7</td>
              <td>7</td>
              <td>9</td>
              <td>10</td>
              <td>12</td>
              <td>13</td>
              <td>14</td>
              <td>16</td>
            </tr>
            <tr>
              <td>Diametrul țevii de sub siguranțele supapei (Du)</td>
              <td>mm</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>20</td>
              <td>20</td>
              <td>20</td>
              <td>25</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>2×50(FL)</td>
              <td>2×50(FL)</td>
              <td>2×50(FL)</td>
            </tr>
            <tr>
              <td>Diametrul orificiului de scurgere a apei din cazan</td>
              <td>mm</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>20</td>
              <td>20</td>
              <td>20</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const TrioUniPelletDimensions = () => {
  const data = [
    { param: "B_min", unit: "mm", values: [1250, 1250, 1300, 1300, 1350, 1450, 1550, 1950, 2050, 2250, 2400, 2450, 2500, 2750, 2870] },
    { param: "B1", unit: "mm", values: [500, 500, 550, 550, 600, 680, 840, 940, 1040, 1160, 1320, 1370, 1420, 1670, 1790] },
    { param: "H", unit: "mm", values: [1060, 1060, 1170, 1220, 1270, 1320, 1450, 1470, 1670, 1770, 1770, 1870, 1870, 1970, 1970] },
    { param: "H1", unit: "mm", values: [990, 990, 1095, 1145, 1195, 1245, 1320, 1340, 1540, 1640, 1640, 1740, 1740, 1840, 1840] },
    { param: "H2", unit: "mm", values: [810, 810, 900, 930, 980, 1030, 1080, 1075, 1265, 1315, 1290, 1365, 1340, 1415, 1415] },
    { param: "H3", unit: "mm", values: [280, 280, 280, 280, 280, 280, 285, 285, 355, 355, 355, 355, 355, 355, 355] },
    { param: "H4", unit: "mm", values: [1230, 1230, 1230, 1230, 1600, 1600, 1700, 1700, 1700, 1700, 1700, 1700, 1700, 1700, 1700] },
    { param: "L", unit: "mm", values: [1470, 1520, 1540, 1800, 1800, 1800, 1950, 2300, 2650, 2800, 3100, 3500, 4000, 4300, 4600] },
    { param: "L1", unit: "mm", values: [880, 930, 1000, 1225, 1225, 1275, 1370, 1530, 1880, 1980, 2285, 2365, 2725, 2880, 3070] }
  ]

  const headers = ["Parametri", "U.M.", "20 kW", "30 kW", "40 kW", "50 kW", "65 kW", "80 kW", "97 kW", "150 kW", "200 kW", "250 kW", "300 kW", "400 kW", "500 kW", "600 kW", "700 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/TrioUniPelletSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};